import { Component } from "react";
import { Translation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import logoSpinner from "./../../images/logoSpinner.svg";

export default class TalaeraSpinner extends Component {
  render() {
    if (this.props.className || this.props.color || this.props.size || this.props.style) {
      const className = this.props.className ? this.props.className : "spinner";

      return (
        <CircularProgress
          size={this.props.size ? this.props.size : 40}
          className={className}
          style={{
            color: this.props.color ? this.props.color : "var(--action-brand)",
            ...this.props.style,
          }}
        />
      );
    } else {
      return (
        <Translation>
          {t => (
            <img
              src={logoSpinner}
              alt={t("Common.spinner.loadingLabel")}
              style={{ width: 50, marginTop: 20 }}
            />
          )}
        </Translation>
      );
    }
  }
}
